import { useTranslation } from 'react-i18next';
import { changeLanguage, getSupportedLanguages } from '../i18n/config';

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const languages = getSupportedLanguages();

  const handleSwitch = (lng: string) => {
    if (lng === i18n.language) return;
    changeLanguage(lng as typeof languages[number]);
  };

  return (
    <div className="language-switcher" aria-label={t('languageSwitcher.label')}>
      {languages.map((lng) => (
        <button
          type="button"
          key={lng}
          onClick={() => handleSwitch(lng)}
          className={`language-switcher__option ${i18n.language.startsWith(lng) ? 'is-active' : ''}`}
          aria-pressed={i18n.language.startsWith(lng)}
        >
          {lng.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
